import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Button from '@material-ui/core/Button';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux';
import { findUserHolding } from '../../redux/action/userActions';
import { giftreset, sendGift } from '../../redux/action/giftActions';
import { getLocalStorage } from '../../utils/localStorage';
import { GiftsHistory } from './GiftHistory';
import {  useSnackbar } from 'notistack';
import { useTitle } from '../../context/TitleProvider';

export const  Gifts = ()  => {
    const {setTitle} = useTitle()
    setTitle("Gifts");
    const dispatch = useDispatch();
    const { userRedux , status, failedMessage} = useSelector(state => ({
      userRedux: state.userState.user,
      status: state.giftState.status,
      failedMessage: state.giftState.failedMessage
    }))
    const user = userRedux || getLocalStorage("user")
    const [holdings, setHoldings] = React.useState([]);
    const [map, setMap] = React.useState(new Map());
  const [instrument, setInstrument] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [quantity, setQuantity] = React.useState(0);
  const { enqueueSnackbar } = useSnackbar();
    React.useEffect($ => {
      dispatch(findUserHolding(user.clientId, setHoldings, setMap))
    }, [ userRedux, user,  dispatch])
    React.useEffect($=>{
        status==="completed" &&  enqueueSnackbar('Gift sent successfully', { variant : 'success' });
        status==="failed" &&  enqueueSnackbar( failedMessage, { variant : 'error' })
        return () => dispatch(giftreset());
     }, [status, dispatch, enqueueSnackbar, failedMessage])
  const handleSubmit = (e) => {
      e.preventDefault();
      if(email === user.email) return
      if(!email || !quantity || !instrument) return
      const payload  = {
            user:{
                clientId: user.clientId
            }, 
            recipient: {
                email
            },
            instrumentData: {
                price:  map.get(instrument),
                quantity,
                instrument
            }

      }
   
       dispatch(sendGift(payload));
  }



  return (
      <>
      <h1>Gift stocks to loved ones</h1>
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
      <div>
        <TextField
          label="Recipient's name (optional)"
          id="outlined-start-adornment"
          sx={{ m: 1, width: '35ch' }}
          
        />
          <TextField
          label="Recipient's email"
          id="outlined-start-adornment"
          sx={{ m: 1, width: '50ch' }}
          value= {email}
          required
          onChange={e => setEmail(e.target.value)}

          
        />
        <FormControl  sx={{ m: 1, width: '50ch' }}>
        <InputLabel id="demo-simple-select-label">Instrument</InputLabel>
        <Select
          labelId="Select Instrument"
          required
          id="instument-select"
          value={instrument}
          label="iNSTRUMENT"
          onChange={e => setInstrument(e.target.value)}

        > 
         {holdings.map((eq) => (
            <MenuItem key={eq._id} value={eq.instrument}>{eq.instrument} (available qty: {eq.quantity})</MenuItem>
         ))}
        </Select>
      </FormControl>
      <TextField
          label="Quantity"
          required
          type="Number"
          id="outlined-start-adornment"
          sx={{ m: 1, width: '50ch' }}
          value= {quantity}        
          onChange={e => setQuantity(e.target.value)}  
      />
         <TextField
          label="Message"
          required
          multiline
          id="outlined-start-adornment"
          sx={{ m: 1, width: '50ch' }}
      />
        <Button
            type="submit"
            halfwidth="true"
            variant="contained"
            color="default"
            style={{height: '50px', padding: '30px', margin: '10px' }}
            onClick={handleSubmit}
          >  
            Send Gift
          </Button>
     
      </div>
    
     
    </Box>
    <GiftsHistory/>
    </>
  );
}


